/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Work_Order_Publish_Status_For_TrackInputs */

const en_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status for ${i?.name}`)
};

const fr_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Statut pour ${i?.name}`)
};

const de_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status für ${i?.name}`)
};

const it_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stato per ${i?.name}`)
};

const ru_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Статус для ${i?.name}`)
};

const es_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estado de ${i?.name}`)
};

const zh_cn2_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 的状态`)
};

const ja_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のステータス`)
};

const hi_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} के लिए स्थिति`)
};

const pt_pt2_work_order_publish_status_for_track = /** @type {(inputs: Work_Order_Publish_Status_For_TrackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status para ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Status for {name}" |
*
* @param {Work_Order_Publish_Status_For_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_for_track = /** @type {((inputs: Work_Order_Publish_Status_For_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_For_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_status_for_track(inputs)
	if (locale === "de") return de_work_order_publish_status_for_track(inputs)
	if (locale === "it") return it_work_order_publish_status_for_track(inputs)
	if (locale === "ru") return ru_work_order_publish_status_for_track(inputs)
	if (locale === "es") return es_work_order_publish_status_for_track(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_status_for_track(inputs)
	if (locale === "ja") return ja_work_order_publish_status_for_track(inputs)
	if (locale === "hi") return hi_work_order_publish_status_for_track(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_status_for_track(inputs)
	return en_work_order_publish_status_for_track(inputs)
});